import React from "react";
import Headline from "./Headline";
import { Button, Flex, Form, FormInstance, Input, Modal, notification } from "antd";
import HomeLink from "../../widgets/HomeLink";
import UserApi from "../../api-services/user-api.service";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { mdiCheckCircle, mdiCheckCircleOutline, mdiCloseCircle } from "@mdi/js";
import Icon from "@mdi/react";
import PasswordChecklist from "react-password-checklist"
import CustomerApi from "../../api-services/customer-api.service";
import ChangePasswordForm from "./ChangePasswordForm";
import { humanize } from "../../utils/helpers";


const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not a valid email!'
  }
};

type FieldType = {
  username?: string;
  password?: string;
};

const bannerPath = '/iceholidays-assets/images/reset_password_cover.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'Reset Password' }
]


function withParams(Component) {
  return props => <Component {...props} navigate={useNavigate()} searchParams={useSearchParams()} params={useParams()}/>;
}

class ResetPasswordPage extends React.Component <{navigate, searchParams, params}>  {
  api = UserApi;
  resetPasswordForm = React.createRef<FormInstance>();

  state = {
    password: "",
    confirm: "",
    signInPath: "partner-sign-in"
  }

  componentDidUpdate(prevProps: Readonly<{ navigate: any; searchParams: any; params: any; }>, prevState: Readonly<{}>, snapshot?: any): void {
    
  }

  componentDidMount() {
    if(this.props.params.scope == 'customers'){
      this.api = CustomerApi;
      this.setState({signInPath: "sign-in"})
    }
  }

  success = () => {
    Modal.success({
      icon: null,
      title: <h3> <Icon path={mdiCheckCircleOutline} size={1} /> Password Reset Successful! </h3>,
      content: <div>
                  <p>Your password has been reset.</p>
                  <p>All existing accounts have been logged out, please login with your new password again.</p>
                </div>,
      footer: <Flex align="center" justify="center">
                <Button type="primary" href={`/web/${this.state.signInPath}`}>
                  Login
                </Button>
              </Flex>,
      className: "reset-password-success-modal",
      width: 500,
      closable: true
    });
  };

  submitForm(formValues) {
    const [searchParams] = this.props.searchParams;
    const token = searchParams.get('reset_password_token')
    const params = {
      password: formValues.password,
      password_confirmation: formValues.confirm,
      reset_password_token: token
    }
    this.api.resetPassword(params)
      .then((res:any) => {
        const success = res.status == 204;
        if(success){
          this.success();
        }else{
          var message = "";
          const errors = res.response.data.errors;
          if(errors){
            message = Object.entries(errors).map((error:any) => `${humanize(error[0])} ${error[1].join("and")}`).join("\n")
          }
          if(message != "") notification.error({ message});
        }
      })
      .catch(error => {
        notification.error({ message: error.response.data.error});
      });
  }


  render(){
    return (
      <div id="reset-password" className="gd-series-tour-page">
        <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs}>
          <span className="title">
            Reset Password
          </span>
        </Headline>

        <div className="gd-series-tour-page_body">
          <div id="reset-password-form">
            <ChangePasswordForm submitBtnTxt="Reset" submit={(formValues)=>this.submitForm(formValues)}/>
          </div>
        </div>
      </div>
    )
  }
}

export default withParams(ResetPasswordPage);